export default __webpack_public_path__ + "static/media/Remove.83aa75a6.svg";